module.exports = __webpack_public_path__ + "img/icon_map_53_off_110.a96a6cfb.png";